import React, { useEffect, useRef } from 'react';
import Webamp from 'webamp';

const Winamp = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    let webamp;

    if (Webamp.browserIsSupported()) {
      webamp = new Webamp({
        initialTracks: [
          {
            url: 'https://cdn.jsdelivr.net/gh/captbaritone/webamp@master/mp3/loop.mp3',
            metaData: { title: 'Webamp Sample Track' },
          },
        ],
      });
      // Render when ready ensures assets are loaded
      webamp
        .renderWhenReady(containerRef.current)
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error('Webamp failed to render:', err);
        });
    }

    return () => {
      if (webamp) webamp.dispose();
    };
  }, []);

  return (
    <div className="h-full w-full bg-white overflow-auto" style={{ fontFamily: 'Tahoma, sans-serif' }}>
      <div ref={containerRef} className="p-2" />
    </div>
  );
};

export default Winamp;
